<!-- src/components/icons/HamburgerIcon.vue -->
<template>
  <svg width="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g clip-path="url(#clip0_402_1610)"> <path d="M17.6336 11.5653L12.2393 16.9596L15.3514 20.0717C16.841 21.5613 19.2561 21.5613 20.7457 20.0717C22.2353 18.5821 22.2353 16.167 20.7457 14.6774L17.6336 11.5653Z" stroke="currentColor" stroke-width="1.55182" stroke-linecap="round"></path> <path d="M6.80931 11.2036L12.2036 5.80925L9.09151 2.69715C7.60192 1.20755 5.18681 1.20756 3.69721 2.69715C2.20762 4.18675 2.20762 6.60186 3.69721 8.09146L6.80931 11.2036Z" stroke="currentColor" stroke-width="1.55182" stroke-linecap="round"></path> <path d="M13.1909 15.4215L11.2393 13.4699" stroke="currentColor" stroke-width="1.55182" stroke-linecap="round"></path> <path d="M16.0955 12.5169L14.1439 10.5653" stroke="currentColor" stroke-width="1.55182" stroke-linecap="round"></path> <path d="M20.7456 20.0717L21.9904 21.3165" stroke="#ffffff" stroke-width="1.55182" stroke-linecap="round"></path> <path d="M3.69714 2.69713L2.4523 1.45229" stroke="currentColor" stroke-width="1.55182" stroke-linecap="round"></path> <path d="M11.4094 17.7895L18.4635 10.7354" stroke="currentColor" stroke-width="1.55182" stroke-linecap="round"></path> <path d="M13.0334 4.97935L5.97936 12.0334" stroke="currentColor" stroke-width="1.55182" stroke-linecap="round"></path> </g> <defs> <clipPath id="clip0_402_1610"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </g></svg>
  </template>
  
  <script>
  export default {
    name: "ConnectIcon",
    props: {
      width: {
        type: String,
        default: "20px",
      },
      height: {
        type: String,
        default: "20px",
      },
      strokeColor: {
        type: String,
        default: "#ffffff",
      },
      strokeWidth: {
        type: [String, Number],
        default: 1.5,
      },
    },
  };
  </script>